/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: [],
  error: null,
  // currentDatapipe: {
  //   title: "",
  //   description: "",
  //   customer_code: "",
  //   company_name: "",
  //   collectorConfigs: [],
  //   connectorConfigs: [],
  // },
  currentDatapipe: {
    name: "",
    // description: "",
    companyId: "",
    companyName: "",
    collectorConfigs: [],
    connectorConfigs: [],
  },
  loading: false,
  loaded: true,
  togglingStatus: false,
  toggleStatusResponse: null,
  toggleStatusError: null,
  successResponse: null,
  rerenderAt: new Date().getTime(),
  currentDatapipePlayersVerified: false,
  storeSearch: null,
  filter: null,
  currentDatapipeDel: {},
  hideDatapipeResponse: null,
  hideDatapipeErrorResponse: null,
  datapipeLogLoading: false,
  datapipeLogLoaded: false,
  datapipeLogs: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_DATAPIPE: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_DATAPIPE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        ...action.payload,
      };
    }
    case types.FETCH_DATAPIPE_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_DATAPIPE: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_A_DATAPIPE_SUCCESS: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        currentDatapipe: action.payload,
      };
    }
    case types.FETCH_A_DATAPIPE_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.CHANGE_STATUS_DATAPIPE: {
      return {
        ...state,
        togglingStatus: true,
        toggleStatusResponse: null,
        toggleStatusError: null,
      };
    }
    /* istanbul ignore next */
    case types.CHANGE_STATUS_DATAPIPE_SUCCESS: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: action.payload,
        toggleStatusError: null,
      };
    }
    /* istanbul ignore next */
    case types.CHANGE_STATUS_DATAPIPE_FAILED: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: null,
        toggleStatusError: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.CREATE_PIPE: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    /* istanbul ignore next */
    case types.CREATE_DATAPIPE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.CREATE_DATAPIPE_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.UPDATE_PIPE: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    /* istanbul ignore next */
    case types.UPDATE_DATAPIPE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.UPDATE_DATAPIPE_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.RERENDER_DATAPIPE: {
      return {
        ...state,
        rerenderAt: new Date().getTime(),
      };
    }
    /* istanbul ignore next */
    case types.ADD_COLLECTOR_TO_DATAPIPE: {
      return {
        ...state,
        currentDatapipe: {
          ...state.currentDatapipe,
          collectorConfigs: [
            ...state.currentDatapipe.collectorConfigs,
            action.payload,
          ],
        },
      };
    }
    /* istanbul ignore next */
    case types.CHANGE_CURRENT_DATAPIPE_NAME: {
      return {
        ...state,
        currentDatapipe: {
          ...state.currentDatapipe,
          name: action.payload,
        },
      };
    }
    /* istanbul ignore next */
    case types.RESET_CURRENT_DATAPIPE: {
      return {
        ...state,
        currentDatapipe: {
          ...initialState.currentDatapipe,
        },
        currentDatapipePlayersVerified: false,
        successResponse: null,
      };
    }
    /* istanbul ignore next */
    case types.REMOVE_COLLECTOR_FROM_DATAPIPE: {
      const index = state.currentDatapipe.collectorConfigs.findIndex(
        (config) => config.configId === action.payload,
      );

      state.currentDatapipe.collectorConfigs.splice(index, 1);
      return {
        ...state,
        currentDatapipe: {
          ...state.currentDatapipe,
        },
      };
    }
    /* istanbul ignore next */
    case types.ADD_CONNECTOR_TO_DATAPIPE: {
      return {
        ...state,
        currentDatapipe: {
          ...state.currentDatapipe,
          connectorConfigs: [
            ...state.currentDatapipe.connectorConfigs,
            action.payload,
          ],
        },
      };
    }
    /* istanbul ignore next */
    case types.REMOVE_CONNECTOR_FROM_DATAPIPE: {
      const index = state.currentDatapipe.connectorConfigs.findIndex(
        (config) => config.id === action.payload,
      );
      state.currentDatapipe.connectorConfigs.splice(index, 1);
      return {
        ...state,
        currentDatapipe: {
          ...state.currentDatapipe,
          connectorConfigs: [...state.currentDatapipe.connectorConfigs],
        },
      };
    }
    /* istanbul ignore next */
    case types.ADD_PLAYERDATA_TO_DATAPIPE: {
      const index = state.currentDatapipe.collectorConfigs.findIndex(
        (config) => config.configId === action.payload.collector.configId,
      );
      if (state.currentDatapipe.collectorConfigs[index]) {
        state.currentDatapipe.collectorConfigs[index] =
          action.payload.playerData;
      }
      return {
        ...state,
        currentDatapipe: {
          ...state.currentDatapipe,
        },
      };
    }
    /* istanbul ignore next */
    case types.VERIFY_PLAYERS: {
      return {
        ...state,
        currentDatapipe: {
          ...state.currentDatapipe,
        },
        currentDatapipePlayersVerified: true,
      };
    }
    case types.STORE_DATAPIPE_SEARCH: {
      return {
        ...state,
        storeSearch: action.payload,
      };
    }
    case types.REMOVE_DATAPIPE_SEARCH: {
      return {
        ...state,
        storeSearch: null,
      };
    }
    case types.SET_DATAPIPE_FILTER_ACTIVE_DISABLE: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case types.REMOVE_DATAPIPE_FILTER_ACTIVE_DISABLE: {
      return {
        ...state,
        filter: null,
      };
    }
    case types.FETCH_A_DATAPIPE_DEL: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_A_DATAPIPE_DEL_SUCCESS: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        currentDatapipeDel: action.payload,
      };
    }
    case types.FETCH_A_DATAPIPE_DEL_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.DELETE_DATAPIPE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: null,
      };
    }
    case types.DELETE_DATAPIPE_SUCCESS: {
      return {
        ...state,
        loaded: false,
        loading: true,
        successResponse: action.payload,
      };
    }
    case types.DELETE_DATAPIPE_FAILED: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: action.payload,
      };
    }
    case types.REMOVE_DEL_DATAPIPE: {
      return {
        ...state,
        currentDatapipeDel: {},
        successResponse: null,
      };
    }
    case types.CLEAR_DATAPIPE_LIST: {
      return {
        ...state,
        list: [],
        loading: false,
        loaded: true,
      };
    }
    case types.LOAD_MORE_DATAPIPE_SUCCESS:
      return {
        ...state,
        list: [...state.list, ...action.payload],
        isLoading: false,
      };
    case types.LOAD_MORE_DATAPIPE_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case types.HIDE_DATAPIPE_SUCCESS: {
      return {
        ...state,
        hideDatapipeResponse: action.payload,
      };
    }
    case types.HIDE_DATAPIPE_FAILED: {
      return {
        ...state,
        hideDatapipeErrorResponse: action?.payload?.message,
      };
    }
    case types.CLEAR_ERROR_RESPONSE: {
      return {
        ...state,
        hideDatapipeResponse: null,
        hideDatapipeErrorResponse: null,
      };
    }
    case types.INITIAL_DATAPIPE_VALUE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        currentDatapipe: action?.payload,
      };
    }
    case types.CLEAR_ERROR_DATA_PIPE_RESPONSE: {
      return {
        ...state,
        error: null,
      };
    }
    case types.CLEAR_SUCCESS_DATA_PIPE_RESPONSE: {
      return {
        ...state,
        successResponse: null,
      };
    }
    case types.FETCH_A_DATAPIPE_LOGS: {
      return {
        ...state,
        datapipeLogLoading: true,
        datapipeLogLoaded: false,
        datapipeLogs: [],
      };
    }
    case types.FETCH_A_DATAPIPE_LOGS_SUCCESS: {
      return {
        ...state,
        datapipeLogLoading: false,
        datapipeLogLoaded: true,
        datapipeLogs: action.payload,
      };
    }
    case types.FETCH_A_DATAPIPE_LOGS_FAILED: {
      return {
        ...state,
        datapipeLogLoading: false,
        datapipeLogLoaded: true,
        datapipeLogs: [],
        error: action.payload,
      };
    }
    case types.ADD_SAMPLING_TO_DATAPIPE: {
      return {
        ...state,
        currentDatapipe: {
          ...state.currentDatapipe,
          samplingRate: action.payload,
        },
      };
    }
    default:
      return state;
  }
}
